import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts('appointment-form', 'visit_types-req', [
  'INIT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'visit_types',
    {
      type: 'payload.query',
      queryParameter: 'filter_visit_type_locations',
      selector: 'filterVisitTypeLocations',
    },
    {
      type: 'payload.query',
      queryParameter: 'organization_id',
      selector: 'organizationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'impersonated_user_id',
      selector: 'userId',
    },
    {
      type: 'payload.query',
      queryParameter: 'pbv_config_id',
      selector: 'pbvConfigId',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case APPOINTMENT_PROGRESS_TYPES.SET_ORGANIZATION: {
      return {
        ...state,
        list: [],
      };
    }
    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/visit-types-req.js